module.exports = __webpack_public_path__ + "img/QRcode.535091ea.png";